export default __webpack_public_path__ + "static/media/warningOrange.91e6ef38.svg";